import PropTypes from 'prop-types'

function SettingsCard({ title, description, children, className = '', icon }) {
  return (
    <div
      className={`bg-surface-light dark:bg-surface-dark rounded-xl shadow-md dark:shadow-md p-6 ${className}`}
    >
      <div className="mb-6 text-left w-full">
        <div className="flex items-start space-x-3 w-full">
          {icon && (
            <div className="flex-shrink-0 mt-0.5 text-neutral-600 dark:text-neutral-400">
              {icon}
            </div>
          )}
          <div className="flex-1 min-w-0 text-left">
            <h3 className="text-lg font-semibold text-neutral-900 dark:text-white leading-tight text-left">
              {title}
            </h3>
            {description && (
              <p className="text-sm text-neutral-600 dark:text-neutral-400 mt-2 leading-relaxed text-left">
                {description}
              </p>
            )}
          </div>
        </div>
      </div>
      <div className="space-y-4 w-full">{children}</div>
    </div>
  )
}

SettingsCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  icon: PropTypes.node,
}

export default SettingsCard
